import React, { useContext } from "react";
import { AUTH_OTP, CATEGORY_ADVANCED, CATEGORY_SUBSCRIBER } from "@config/config";
import { ApplicationContext } from "@context/ApplicationContext";

const RedemptionsBar = ({ promoDetails, ticketClass }) => {
    const { whiteLabel } = useContext(ApplicationContext);

    if (!promoDetails) {
        return null;
    }
    if (ticketClass) {
        if (
            promoDetails.promo_category === CATEGORY_ADVANCED && 
            !promoDetails.ticket_classes?.includes(ticketClass)
        ) {
            return null;
        }
        
        if (promoDetails.promo_category === CATEGORY_SUBSCRIBER && 
            !promoDetails.ticket_class_id === ticketClass
        ) {
            return null;
        }
    }

    const redemptionsText = whiteLabel?.redemptions_bar_text?.trim() || whiteLabel?.brand_name;
    
    const isOtpAuth = whiteLabel?.subscriber_group?.authentication_type === AUTH_OTP;
    
    const ticketClassText = promoDetails?.ticket_class_name || "";
    const subscribeRedemptionsText = `My ${ticketClassText} ${redemptionsText}`;

    return (
        <>
            {promoDetails.promo_category === CATEGORY_ADVANCED ? (
                <div className="redemptions__wrapper" key={promoDetails?.value}>
                    <div className="redemptions__text"> {redemptionsText}</div>
                    <div className="redemptions__counter"> {promoDetails?.promo_reuse_count} / {promoDetails?.reuse_limit} used </div>
                </div>
            ) : null}

            {promoDetails.promo_category === CATEGORY_SUBSCRIBER && !promoDetails?.is_over_limit ? (
                <div className="redemptions__wrapper" key={promoDetails?.value}>
                    <div className="redemptions__text">{isOtpAuth ? subscribeRedemptionsText : promoDetails?.ticket_class_name}</div>
                    <div className="redemptions__counter"> {promoDetails?.tickets_available} available </div>
                </div>
            ) : null}
        </>
    );
};

export default RedemptionsBar;
